// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"78ad703b","172":"26fb18d8","213":"cd46c58a","239":"cf05bff1","250":"f8b7858a","455":"b0aad944","762":"468b87e0","777":"f64c8404"}[chunkId] + ".chunk.js";
};